import {combineReducers} from '@ngrx/store';
import {meetingsListFeatureKey, meetingsListReducer, MeetingsListState} from '@communication/meetings/_store/mettings.reducer';
import {meetingItemFeatureKey, meetingItemReducer, MeetingItemState} from '@communication/meetings/components/meeting-item/_store/meeting-item.reducer';

export const meetingsFeatureKey = 'meetings';

export interface MeetingsState {
    [meetingsListFeatureKey]: MeetingsListState,
    [meetingItemFeatureKey]: MeetingItemState
}

export const meetingsReducers = combineReducers(
    {
        [meetingsListFeatureKey]: meetingsListReducer,
        [meetingItemFeatureKey]: meetingItemReducer
    }
);
